<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<div class="image"><img alt="image" src="images/002.jpg"/></div>
<h1 class="subtitle">Profit for Your Workplace and the Environment</h1><br/><br/>
<h2 class="author">Pamela J. Gordon</h2><br/><br/>
<div class="image"><img alt="image" src="images/00001.jpg"/></div>
<p><span>BERKETT-KOEHLER PUBLISHERS, INC.<br/>San Francisco</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?8a95bafc